import React from 'react'
import ReactDOM from 'react-dom/client'
import 'react-datepicker/dist/react-datepicker.css'
import './index.css'
import reportWebVitals from './reportWebVitals'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './utils/store'
import i18n from './i18n'
import { I18nextProvider } from 'react-i18next'
import { ThemeProvider, createTheme } from '@mui/material/styles'

// Create a theme instance
const theme = createTheme({
	// You can customize your theme here
	// For example:
	// palette: {
	//   primary: {
	//     main: '#556cd6',
	//   },
	//   secondary: {
	//     main: '#19857b',
	//   },
	// },
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<I18nextProvider i18n={i18n}>
				<Provider store={store}>
					<App />
				</Provider>
			</I18nextProvider>
		</ThemeProvider>
	</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
